<mpro-text-input [title]="title" info="Max 12 characters" errorMsg="Max: 12 characters"
    [(ngModel)]="dashboardFilter.name" [inputState]="inputState" (keyup)="keyup()" placeholder=""></mpro-text-input>

<div class="buttons">
    <button class="mpro-btn mpro-btn-secondary" (click)="cancelClick()" stopClickPropagation>
        Cancel
    </button>
    <button class="mpro-btn mpro-btn-primary save-btn" [disabled]="dashboardFilter.name?.length === 0" (click)="saveClick()"
        stopClickPropagation>
        <span>Save</span>
        <fa-icon class="lockIcon" *ngIf="!authService.isLoggedIn()" [icon]="faLock"></fa-icon>
    </button>
</div>